import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Tab, Tabs, Grid, IconButton, ButtonBase } from '@material-ui/core';
import HomeList from './Homelist';
import Homeflowlist from './Homeflowlist';
import HomeNews from './HomeNews';
import AppUtils from '../../control/apputlis';
import DeviceEventEmitter, { EventName } from '../../control/event';

import "../../css/home.css";
import Apis from '../../network/Apis';
import MStatusBar from '../view/MStatusBar';
import AppData from '../../model/AppData';
import Download from './Download';
import MEnvelope from '../view/MEnvelope';
import TabIndicator from '../view/TabIndicator';

const SEARCH_ICON = require("../../images/icons/sousuo_icon.png");
const HISTORY_ICON = require("../../images/icons/lishi_icon.png");
const BBQ_ICON = require("../../images/change/bbq.png");


const HOME_TAB_INDEX_KEY = 'HOME_TAB_INDEX_KEY';
const ICON1 = require("../../images/icons/gengduo_icon.png");

class HomePage extends React.Component {
    constructor(props) {
        super(props);
        var tabIndex = AppUtils.getStorageInt(HOME_TAB_INDEX_KEY);
        this.state = {
            tabIndex: tabIndex,
            searchVal: '',
            LIST_CFG: [{ type: 0, flow: false, id: 0, logo: '', name: '推荐', type_id: 1, view: <HomeList type={1} /> },],
        };
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.HOME_SWIPER_INDEX, this._swiperIndex, this);
        this.getRecommType();
        AppData.checkUpdate();
        AppUtils.YMPush('MAIN', 'HomePage');

        // AppData.getLocation();
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.HOME_SWIPER_INDEX, this._swiperIndex, this);
    }

    isWebClip = () => {
        let webclip = AppUtils.getQueryVariable('webclip');
        if (webclip && webclip == 1) {
            return true;
        }
        return false;
    }

    getRecommType = async () => {

        let data = [];
        let localChannels = AppUtils.getStorageObj(AppUtils.CUSTOM_CHANNELS);
        if (localChannels != null) {
            data = localChannels;
        } else {
            let result = await Apis.encryptionRecommType();
            if (result.code == 200) {
                data = result.data;
                AppUtils.setStorageObj(AppUtils.CUSTOM_CHANNELS, data);
            }
        }

        let LIST_CFG = [];
        LIST_CFG[0] = { type: 0, flow: false, id: 0, logo: '', name: '推荐', type_id: 1, view: <HomeList type={1} /> }
        LIST_CFG[1] = { type: 0, flow: false, id: 0, logo: '', name: '新闻', type_id: 1, view: <HomeNews type={1} /> }
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            LIST_CFG[i + 2] = { type: 1, flow: true, name: element.name, id: element.id, type_id: element.id, view: <Homeflowlist type={element.id} /> }
        }
        this.setState({ LIST_CFG: LIST_CFG });

    }

    _swiperIndex = (result) => {
        this.setState({
            tabIndex: Number(result),
        });
        AppUtils.setStorageItem(HOME_TAB_INDEX_KEY, result);
    }

    onTabChange = (event, newValue) => {
        console.log('onTabChange=', newValue)
        this._swiperIndex(newValue);
        DeviceEventEmitter.emit(EventName.HOME_SWIPER_INDEX, newValue);
    }

    _onSearchClick = (e) => {
        this.props.history.push({ pathname: '/search' });
    }

    _onClickEdit() {
        this.props.history.push({ pathname: '/customchannel' });
    }

    _renderTopTabs = () => {
        const { tabIndex, LIST_CFG } = this.state;
        console.log('_renderTopTabs', LIST_CFG);
        return (
            <Grid container direction='row' alignItems='center' justify='space-between'>
                <Grid container direction='row' style={{ width: 'calc(100vw - 40px)', flex: 1, marginLeft: 8 }}>
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        value={Number(tabIndex)}
                        onChange={(e, value) => this.onTabChange(e, value)}
                        aria-label="simple tabs example"
                        TabIndicatorProps={{ children: <TabIndicator color="#FFF" />, style: { backgroundColor: 'transparent', marginBottom: 3 } }}
                    >
                        {
                            LIST_CFG.map((item, i) => (
                                <Tab key={i + ''} wrapped={false} label={item.name} style={{ color: '#FFF', opacity: 1, fontSize: tabIndex == i ? 17 : 14, height: '100%', padding: 0, fontWeight: tabIndex == i ? 'bold' : 'inherit' }}></Tab>
                            ))
                        }
                    </Tabs>
                </Grid>
                <Grid container direction='row' justify="center" style={{ width: 32 }}>
                    <ButtonBase disableRipple onClick={() => this._onClickEdit()}>
                        <img src={ICON1} style={{ width: 15, height: 15 }}></img>
                    </ButtonBase>
                </Grid>
            </Grid>
        )
    }

    _renderSearchBar = () => {
        const { classes } = this.props;
        const { searchVal } = this.state;
        return (
            <Grid className={classes.toolBar} direction='row' container alignItems='center'>
                <img src={BBQ_ICON} className={classes.bbq}></img>
                <Grid className={classes.inputBg} direction='row' justify='flex-start' container alignItems='center' >
                    <img alt='search' src={SEARCH_ICON} className={classes.toolIcon} style={{ color: '#FFF', marginLeft: 8 }} />
                    <form action="">
                        <input
                            type='text'
                            type="search"
                            onChange={event => this.setState({ searchVal: event.target.value })}
                            value={searchVal}
                            onClick={this._onSearchClick}
                            className={classes.searchInput}
                            placeholder='点击搜索主播/比赛/联赛...' />
                    </form>
                </Grid>
                <IconButton onClick={() => this.props.history.push('/history')} className={classes.historyBg}>
                    <img alt='search' src={HISTORY_ICON} className={classes.historyIcon} />
                </IconButton>
            </Grid>
        )
    }

    render() {
        const { classes } = this.props;
        const { tabIndex } = this.state;

        let isWebClip = this.isWebClip();

        return (
            <React.Fragment>
                <div className={classes.topContainer} style={{ zIndex: 1, position: 'relative' }}>
                    {/* <div position='fixed' className={classes.bg}></div> */}
                    <div position='fixed' className={classes.appbar}>
                        <MStatusBar />
                        {this._renderSearchBar()}
                        {this._renderTopTabs()}
                    </div>
                    <div className={classes.pannel}>
                        <Grid container className={classes.pannel1}>
                            {tabIndex == 0 && <HomeList type={tabIndex} />}
                            {tabIndex == 1 && <HomeNews type={tabIndex} />}
                            {tabIndex != 1 && tabIndex != 0 && <Homeflowlist type={tabIndex} />}
                        </Grid>
                    </div>
                    {/* <MEnvelope bottom={123} /> */}
                    {!isWebClip && <Download />}
                </div>
            </React.Fragment >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    bg: {
        position: 'fixed',
        top: 0,
        width: '100vw',
        height: '50vw',
    },
    appbar: {
        width: '100vw',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        background: 'linear-gradient(135deg, #15A5B6, #3AF23A)',
    },
    topContainer: {
        width: '100vw',
        backgroundColor: 'transparent',
    },
    toolBar: {
        width: '100vw',
        padding: theme.spacing(2, 1, 1, 1),
    },
    inputBg: {
        backgroundColor: '#237A1F',
        height: theme.typography.pxToRem(30),
        borderRadius: theme.typography.pxToRem(13.5),
        marginRight: theme.spacing(1),
        flex: 1,
        padding: theme.spacing(0, 1, 0, 1),
        zIndex: 1001,
    },
    logoBack: {
        padding: 0,
        margin: theme.spacing(0, 1, 0, 0)
    },
    historyBg: {
        height: theme.typography.pxToRem(27),
        borderRadius: theme.typography.pxToRem(24),
        width: theme.typography.pxToRem(27),
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        color: theme.palette.secondary.main,
        padding: 0,
        margin: theme.spacing(0, 1, 0, 1)
    },
    bbq: {
        width: 55,
        height: 20,
        marginRight: theme.spacing(1),
        zIndex: 1001,
    },
    toolIcon: {
        width: 16,
        height: 16,
    },
    historyIcon: {
        width: 20,
        height: 20,
    },
    toolLogo: {
        width: 38,
        height: 27,
    },
    searchInput: {
        flex: 1,
        width: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#FFF',
        fontSize: theme.typography.pxToRem(11),
    },
    pannel: {
        width: '100vw',
        height: "calc(100vh - 147px)",
        display: 'flex',
        padding: theme.spacing(0, 0, 0, 0),
    },
    pannel1: {
        width: '100vw',
        flexDirection: 'column',
        backgroundColor: '#fff',
        padding: theme.spacing(0, 0, 0, 0),
        height: '100%'
    },
}))(HomePage));